import { render, staticRenderFns } from "./ExplanationImageUpload.vue?vue&type=template&id=0a3c6a70&"
import script from "./ExplanationImageUpload.vue?vue&type=script&lang=ts&"
export * from "./ExplanationImageUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports